import { Heading } from "@bolt/components";

import "./Logos.css";
import { ComponentProps } from "react";

export const ChatGPCLogomark = (props: ComponentProps<"img">) => <img src="/gpc_logo.png" alt="GPC logo" {...props} />;

export const ChatGPCLogo = () => {
  return (
    <>
      <ChatGPCLogomark alt="" />
      <Heading variant="lg" level="h2" className="app-logo">
        ChatGPC
      </Heading>
    </>
  );
};

export const AskGPCLogomark = (props: ComponentProps<"img">) => (
  <img className="ask-gpc-logo" src="/ask_gpc_logo.png" alt="AskGPC logo" {...props} />
);

export const AskGPCLogo = () => {
  return (
    <>
      <AskGPCLogomark alt="" />
      <Heading variant="lg" level="h2" className="app-logo">
        AskGPC
      </Heading>
    </>
  );
};
